<template>
  <div class="card-wrapper card-video">
    <div
      class="card"
      v-for="techtalk in techtalks.models"
      :key="techtalk.id"
    >
      <a
        :href="techtalk.playlistUrl"
        target="_blank"
        rel="noopener nofollow"
      >
        <span class="card-label">
          <i />
          <span>Watch Now</span>
        </span>

        <img
          :src="techtalk.thumbnailUrl"
          :alt="techtalk.title"
        />
      </a>

      <div class="header-primary">{{ techtalk.title }}</div>
    </div>
  </div>
</template>

<script>
import httpClient from '@utils/http_client'

import { TechtalkVideosList } from '@models/techtalk_video'

export default {
  data: () => ({
    techtalks: new TechtalkVideosList()
  }),
  created() {
    httpClient
      .get('/techtalks?maxResults=5')
      .then(response => {
        const filteredItems = response.data.items.filter((item) => item.contentDetails.videoPublishedAt).slice(0, 3);
        this.techtalks = new TechtalkVideosList(filteredItems)
      })
  }
}
</script>
